import axios from 'axios';
import { Category } from '../components/products-page/components/products-categories/models/Category.model';
import { FixcenterFilterDto } from '../components/product-filters-menu/models/fixcenter-filter-dto.model';
import { IProductPricingInput } from '../shared/models/product-pricing-input.interface';
import { ISearchFilter } from '../shared/models/searched-products-filters.interface';

export const getProductById = (id: string): any => {
    return axios.get<string>(`products/product/${id}`);
};

export const getProductImage = (productId: string): any => {
    return axios.get('Images/products/' + productId);
};
export const getFixcenterProductByCategoryId = (id: string, categoryUuid: string): any => {
    const languageCode = localStorage.getItem('lang');
    return axios.get(`products/fixcenterProductsByCategoryId/${id}/${categoryUuid}/${languageCode}`);
};

export const getFixcenterCategories = (fixcenterFilter: FixcenterFilterDto, directoryId?: string): any => {
    if (directoryId && fixcenterFilter.productFilter) {
        fixcenterFilter.productFilter.parentProductId = directoryId;
    }
    return axios.post<Category[]>('categories/fixcenterProducts', fixcenterFilter);
};

export const getFixcenterFilteringCategories = (categoryId: string): any => {
    const languageCode = localStorage.getItem('lang');
    return axios.get(`products/fixcenterFilteringCategories/${categoryId}/${languageCode}`);
};

export const getFixcenterSearchedProducts = (filters: ISearchFilter): any => {
    return axios.post<Category[]>('products/Search', filters);
};

export const getRelatedProducts = (categoryUuid: string, languageCode: string | null): any => {
    return axios.get(`products/GetRelatedProducts/${categoryUuid}/${languageCode}`);
};

export const getTranslateNameByProductUuid = (productUuid: string, languageCode: string | null): any => {
    return axios.get(`products/GetTranslateNameByProductUuid/${productUuid}/${languageCode}`);
};

export const getProductsPricingDetails = (input: IProductPricingInput) => {
    return axios.post(`products/GetProductsPricingDetails`, input);
};
